import React from 'react';

import Modal from './Modal';

const ModalHeader = (data) => (
  <Modal.Consumer>
    {(context) => (
      <div className="modal-header">
        {typeof data.children === 'function'
          ? data.children(context)
          : data.children}
      </div>
    )}
  </Modal.Consumer>
);

export default ModalHeader;
